export default {
  app: {
    name: 'Sistema de Gestión Comercial',
    welcome: 'Bienvenido',
    logout: 'Cerrar sesión',
    dashboard: 'Panel de Control',
    language: 'Idioma',
    spanish: 'Español',
    english: 'Inglés',
  },
  auth: {
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    username: 'Usuario',
    password: 'Contraseña',
    email: 'Correo electrónico',
    fullName: 'Nombre completo',
    noAccount: '¿No tienes cuenta?',
    hasAccount: '¿Ya tienes cuenta?',
    loginSuccess: 'Inicio de sesión exitoso',
    loginError: 'Credenciales incorrectas',
    registerSuccess: 'Usuario registrado exitosamente',
  },
  nav: {
    companies: 'Empresas',
    partners: 'Socios',
    inventory: 'Inventario',
    invoicing: 'Facturación',
    accounting: 'Contabilidad',
    repair: 'Reparaciones',
    wallet: 'Monedero',
    chartOfAccounts: 'Plan de Cuentas',
    journalEntries: 'Asientos Contables',
    libroMayor: 'Libro Mayor',
    libroVentas: 'Libro de Ventas',
    libroCompras: 'Libro de Compras',
    declaracionIVA: 'Declaración IVA',
    retenciones: 'Retenciones',
    ingresos: 'Ingresos',
    patrimonio: 'Patrimonio',
    estadoResultados: 'Estado de Resultados',
    balanceGeneral: 'Balance General',
    formulario350: 'Formulario 350',
  },
  purchases: {
    title: 'Compras',
    paymentMethod: {
      CASH: 'Efectivo',
      BANK_TRANSFER: 'Transferencia',
      CHECK: 'Cheque',
      CREDIT: 'Crédito'
    },
    status: {
      DRAFT: 'Borrador',
      ISSUED: 'Emitida',
      PAID: 'Pagada',
      PARTIAL: 'Parcial',
      OVERDUE: 'Vencida',
      CANCELLED: 'Cancelada'
    }
  },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    loading: 'Cargando...',
    noData: 'No hay datos disponibles',
    confirm: 'Confirmar',
    actions: 'Acciones',
    total: 'Total',
    subtotal: 'Subtotal',
    tax: 'Impuesto',
    date: 'Fecha',
    status: 'Estado',
    name: 'Nombre',
    description: 'Descripción',
    exportCSV: 'Exportar CSV',
    from: 'Desde',
    to: 'Hasta',
    filter: 'Filtrar',
    close: 'Cerrar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    dateFrom: 'Fecha Desde',
    dateTo: 'Fecha Hasta',
    cutDate: 'Fecha de Corte',
    period: 'Período',
    export: 'Exportar',
    viewDetail: 'Ver Detalle',
    received: 'Recibido',
    diagnosis: 'Diagnóstico',
    approved: 'Aprobado',
    in_repair: 'En Reparación',
    waiting_parts: 'Esperando Repuestos',
    ready: 'Listo',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
  },
  partners: {
    title: 'Gestión de Socios',
    createPartner: 'Crear Socio',
    nit: 'NIT',
    dv: 'Dígito de Verificación',
    partnerType: 'Tipo de Socio',
    fiscalResponsibility: 'Responsabilidad Fiscal',
    customer: 'Cliente',
    supplier: 'Proveedor',
    both: 'Ambos',
    creditLimit: 'Límite de Crédito',
  },
  inventory: {
    title: 'Inventario',
    createProduct: 'Crear Producto',
    sku: 'SKU',
    barcode: 'Código de Barras',
    scanBarcode: 'Escanear Código',
    stockLevel: 'Nivel de Stock',
    minStock: 'Stock Mínimo',
    maxStock: 'Stock Máximo',
    purchasePrice: 'Precio de Compra',
    salePrice: 'Precio de Venta',
    lowStock: 'Stock Bajo',
  },
  invoicing: {
    title: 'Facturación',
    createInvoice: 'Crear Factura',
    invoiceNumber: 'N° Factura',
    invoiceType: 'Tipo de Factura',
    sale: 'Venta',
    purchase: 'Compra',
    sendToDian: 'Enviar a DIAN',
    creditNote: 'Nota Crédito',
    debitNote: 'Nota Débito',
    estadoDian: 'Estado DIAN',
    draft: 'Borrador',
    sent: 'Enviado',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
  },
  accounting: {
    title: 'Contabilidad',
    createEntry: 'Crear Asiento',
    debit: 'Debe',
    credit: 'Haber',
    accountCode: 'Código',
    accountName: 'Nombre de Cuenta',
    accountType: 'Tipo de Cuenta',
    postEntry: 'Publicar Asiento',
    balance: 'Saldo',
    assets: 'Activos',
    liabilities: 'Pasivos',
    equity: 'Patrimonio',
    revenue: 'Ingresos',
    expenses: 'Gastos',
    costs: 'Costos',
    netIncome: 'Utilidad Neta',
    grossProfit: 'Utilidad Bruta',
    initialBalance: 'Saldo Inicial',
    finalBalance: 'Saldo Final',
    debits: 'Débitos',
    credits: 'Créditos',
    balanced: 'Cuadrado',
    notBalanced: 'Descuadrado',
    income: 'Ingresos',
    operationalIncome: 'Ingresos Operacionales',
    nonOperationalIncome: 'Ingresos No Operacionales',
    grossIncome: 'Ingreso Bruto',
    costOfSales: 'Costo de Ventas',
    operatingExpenses: 'Gastos Operacionales',
    financialExpenses: 'Gastos Financieros',
    totalExpenses: 'Total Gastos',
    currentAssets: 'Activos Corrientes',
    nonCurrentAssets: 'Activos No Corrientes',
    totalCurrent: 'Total Corrientes',
    totalNonCurrent: 'Total No Corrientes',
    totalAssets: 'Total Activos',
    currentLiabilities: 'Pasivos Corrientes',
    nonCurrentLiabilities: 'Pasivos No Corrientes',
    totalLiabilities: 'Total Pasivos',
    totalEquity: 'Total Patrimonio',
    retainedEarnings: 'Resultado del ejercicio',
    utilidad: 'Utilidad del ejercicio',
    equation: 'Ecuación',
  },
  repair: {
    title: 'Reparaciones',
    createOrder: 'Crear Orden',
    orderNumber: 'N° Orden',
    status: 'Estado',
    technician: 'Técnico',
    warranty: 'Garantía',
    received: 'Recibido',
    diagnosis: 'Diagnóstico',
    approved: 'Aprobado',
    inRepair: 'En Reparación',
    waitingParts: 'Esperando Repuestos',
    ready: 'Listo',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
    generateInvoice: 'Generar Factura',
  },
  wallet: {
    title: 'Monedero',
    deposit: 'Depositar',
    withdraw: 'Retirar',
    balance: 'Saldo',
    transactions: 'Transacciones',
    loyaltyPoints: 'Puntos de Lealtad',
    redeemPoints: 'Canjear Puntos',
  },
  platform: {
    title: 'Plataforma',
    tenants: 'Empresas',
    createTenant: 'Crear Empresa',
    tenantDetail: 'Detalle de Empresa',
    active: 'Activo',
    inactive: 'Inactivo',
    activate: 'Activar',
    deactivate: 'Desactivar',
    adminUser: 'Usuario Administrador',
    users: 'Usuarios',
    toggleActive: 'Cambiar Estado',
  },
}
